import type { PeriodDto } from "@/lib/api";
import type { Period } from "@/types/time.types";

const TIMEZONE_TO_IANA: Record<string, string> = {
	BRUSSELS: "Europe/Brussels",
	LONDON: "Europe/London",
	NEW_YORK: "America/New_York",
};

function toIanaTimezone(timeZone?: string): string | undefined {
	if (!timeZone) return undefined;
	return TIMEZONE_TO_IANA[timeZone] ?? timeZone;
}

export function toPeriod(
	dto: PeriodDto | null | undefined
): Period | undefined {
	if (!dto) return undefined;

	return {
		start: dto.start,
		end: dto.end,
		timeZone: toIanaTimezone(dto.timeZone),
	};
}
